/**
 * ZapSEA JavaScript SDK
 * 
 * A production-ready JavaScript SDK for the ZapSEA Intelligence Engine API V2.
 * Provides simple, async-first interfaces for policy impact simulation and analysis.
 * 
 * @example
 * ```typescript
 * import { ZapSEA } from 'zapsea';
 * 
 * // Initialize client
 * const client = new ZapSEA({
 *   apiKey: 'pk_live_your_api_key_here'
 * });
 * 
 * // Run impact simulation
 * const job = await client.impact.simulate({
 *   policyDescription: 'AI regulation for financial services',
 *   analysisDepth: 'comprehensive'
 * });
 * 
 * // Wait for completion
 * const result = await client.jobs.waitForCompletion(job.jobId);
 * console.log('Analysis complete:', result.resultData);
 * ```
 */

// Main client
export { ZapSEA } from './client';

// Resource classes
export * from './resources';

// Type definitions
export * from './types';

// Error classes
export * from './errors';

// Utility functions (selective export)
export { validateApiKey, validateJobId } from './utils';

// Version
export const VERSION = '1.0.0';
